import { type Theme } from "@mui/material"
import { OfferItemTheme } from "core/themes/src/definitions/components.types"

export const createOfferItemTheme = (_: Theme): OfferItemTheme => ({
    styleOverrides: {
        erp: {
            flexDirection: "row",
            justifyContent: "space-between",
        },
    },
})
